module.exports = __webpack_public_path__ + "static/media/CheckoutButtons.25f85b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/CheckoutButtons.png
// module id = 941
// module chunks = 0